export default "__VITE_ASSET__f0175e5d__"